
import Vue from "vue";
export default Vue.extend({
  name: "editor-inline-editable",
  props: {
    value: {
      type: String,
    },
    canEdit: {
      type: Boolean,
    },
    tag: {
      type: String,
    },
  },
  data: () => ({
    canUpdate: true,
    tempValue: "",
  }),
  watch: {
    value(val: any) {
      if (this.canUpdate) {
        (this as any).$refs.editable.innerText = val;
      }
    },
  },
  mounted() {
    (this as any).$refs.editable.innerText = this.value;
    this.tempValue = this.value;
  },
  methods: {
    onInput(e: any) {
      this.$emit("input", e.target.innerText);
    },

    onFocus() {
      this.canUpdate = false;
    },

    onBlur(e: any) {
      this.canUpdate = true;
      if (this.tempValue == e.target.innerText) return;
      this.$emit("change", e.target.innerText);
    },
  },
});
